
import original1 from "../Images/original.png"
import original2 from "../Images/original(1).png"
import original3 from "../Images/original(2).png"

const versaData = [
    {
        id: 1,
        src: original1,
        title: "Fitbit Versa 2",
        price: "$199.95"
    },
    {
        id: 2,
        src: original2,
        title: "Fitbit Versa 2 Special Edition",
        price: "$299.95"
    },
    {
        id: 3,
        src: original3,
        title: "Fitbit Versa Lite",
        price: "$159.95"
    }

]

export default versaData